export const MAX_DISPLAY_LENGTH = 10000;
export const MIN_COLUMN_WIDTH = 70;
